import React from "react"
import {Link} from "gatsby";

const DropDownMenuBlock = (props) => (
    <div className="col-md-4">
        <Link to={props.link} className="dropdown__block">
            <img src={props.icon.publicURL} alt="icon"/>
            <div>
                <h4>{props.h4}</h4>
            </div>
        </Link>
    </div>
)

export default DropDownMenuBlock